const CAP_INSTALAR_NODO_BITCOIN = {
  id: 311,
  title: "Instalar un nodo de Bitcoin",
  slug: "instalar-nodo-bitcoin",
  type: "lesson",
  category: "bitcoin-avanzado",
  level: "advanced",
  preview:
    "Cómo funciona un nodo de Bitcoin, sus requisitos, y los pasos esenciales para instalarlo correctamente utilizando Bitcoin Core.",
  sections: [
    {
      heading: "¿Por qué instalar un nodo de Bitcoin?",
      text: [
        "Para que la red Bitcoin pueda validar y transmitir transacciones son necesarios más elementos además de los mineros. Mediante el uso de un número de nodos seleccionados al azar, la red puede reducir las probabilidades de que suceda un problema como el doble gasto y mantener la seguridad e integridad de la misma de forma completa.",
        "Un nodo Bitcoin puede desempeñar distintos roles en función de su utilidad. Los más frecuentes son:",
        "- **Base de datos de la cadena de bloques:** todo monedero que disponga de una copia de la blockchain completa puede actuar como nodo.",
        "- **Minería:** para que un equipo de minado pueda trabajar, requiere también una copia de la totalidad de la cadena de bloques, por lo que podría actuar como nodo."
      ]
    },

    {
      heading: "Requisitos previos para instalar un nodo Bitcoin",
      text: [
        "Para llevar a cabo de forma exitosa la instalación de un nodo Bitcoin, se requiere disponer de la última versión del monedero Bitcoin Core instalada en el sistema operativo del dispositivo que vaya a correr el nodo. Dicho dispositivo debe cumplir con las siguientes características:",
        "- Ordenador, servidor o dispositivo con versiones recientes de Windows, Mac OSX o Linux.",
        "- **2 GB de RAM como mínimo** para sistemas operativos de 32 bits (recomendable 4 GB), **8 GB de RAM** para sistemas de 64 bits, procesador de doble núcleo o superior.",
        "- **7 GB de espacio libre** para nodos podados ó **250 GB para nodos completos** (recomendable mínimo 500 GB).",
        "- Una conexión a Internet con, al menos, **400 kilobits/segundo** (50 KB/s).",
        "- En nodos completos, disponibilidad mínima de **6 horas al día** conectados como nodo.",
        "- El dispositivo no puede entrar en modo reposo o reducir sus capacidades operativas."
      ]
    },

    {
      heading: "Instalación paso a paso",
      text: [
        "Un nodo Bitcoin no produce un gasto eléctrico destacable; no se trata de un nodo minero. No obstante, es común utilizar ordenadores o dispositivos dedicados para correr estos nodos.",
        "Lo fundamental es contar con almacenamiento suficiente para la sincronización inicial, que supera los **200 GB**. Después, si se desea, la blockchain puede podarse para conservar solamente parte de su historial y continuar desde allí hacia adelante.",
        "Para conocer en detalle el procedimiento de instalación de un nodo, se recomienda revisar las instrucciones oficiales de Bitcoin Core, donde se explica paso a paso cómo instalar, sincronizar y configurar un nodo completo en cualquier sistema operativo."
      ]
    }
  ]
};

export default CAP_INSTALAR_NODO_BITCOIN;

